import { Card, H1, H5 } from "@blueprintjs/core";
import React from "react";
import "./LandingPage.scss";
import { Link, Outlet } from "react-router-dom";
export default function LandingPage() {
    return (
        <>
            <div className="landingPage">
                <div className="page-left">
                    <div className="page-title">
                        <H1>Automation</H1>
                        <H1 className="line2">Console</H1>
                        <div className="description">
                            <p>Leverage the tools of AMP to automate your tasks. </p>
                        </div>
                    </div>
                </div>
                <div className="title-cards">
                    <Link to="project/runs" className="no-style-link">
                        <Card id="projects-card" interactive>
                            <H5>Project</H5>
                            <p>Create and manage project schedules and actions. View Project run history.</p>
                        </Card>
                    </Link>
                    <Link to="policies" className="no-style-link">
                        <Card id="policies-card" interactive>
                            <H5>Policy</H5>
                            <p>Create and manage policy actions for client companies.</p>
                        </Card>
                    </Link>
                    <Link to="diagnostics" className="no-style-link">
                        <Card id="diagnostics-card" interactive>
                            <H5>Diagnostics</H5>
                            <p>Help diagnose issues with automation.</p>
                        </Card>
                    </Link>
                </div>
            </div>

            <Outlet />
        </>
    );
}
